<!-- 副页标题盒子 -->
<template>
  <div :class="['sub-title-box', theme]">
    <div class="flex">
      <div class="title">{{ title }}</div>
      <div class="square"></div>
    </div>
    <div class="en">{{ en }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["title", "en", "theme"],
  methods: {},
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;

  .title {
    font-size: 44px;
    color: #454545;
  }
  .square {
    width: 17px;
    height: 17px;
    background: #a01b1b;
    margin-left: 20px;
  }
}
.en {
  margin-top: 20px;
  font-size: 18px;
  color: #454545;
}
.white {
  .flex {
    .title {
      color: #fff;
    }
    .square {
      background: #fff;
    }
  }
  .en {
    color: #fff;
  }
}

@media (max-width: 750px) {
  .flex {
    .title {
      font-size: 24px;
    }
    .square {
      width: 10px;
      height: 10px;
      margin-left: 10px;
    }
  }
  .en {
    margin-top: 10px;
    font-size: 14px;
  }
}
</style>
